function attachmentUrl(url, filename) {
  try {
    const parsed = new URL(url, window.location.href);

    // OCI supports overriding Content-Disposition on GetObject requests. This
    // lets the browser stream the response straight into its download manager
    // instead of waiting for JavaScript to fetch the entire file as a blob.
    if (parsed.hostname.includes('.objectstorage.')) {
      const safeFilename = String(filename || 'download').replace(/["\r\n]/g, '_');
      parsed.searchParams.set(
        'httpResponseContentDisposition',
        `attachment; filename="${safeFilename}"`,
      );
    }

    return parsed.href;
  } catch {
    return url;
  }
}

export function triggerBrowserDownload(url, filename) {
  const anchor = document.createElement('a');
  anchor.href = attachmentUrl(url, filename);
  anchor.download = filename;
  anchor.rel = 'noopener noreferrer';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}

export function videoDownloadFilename(channelName, videoTitle, extension, fallbackTitle) {
  const safePart = (value, fallback) =>
    String(value || fallback)
      .replace(/[^a-z0-9_-]+/gi, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 80) || fallback;

  const channel = safePart(channelName, 'no-channel');
  const title = safePart(videoTitle, fallbackTitle);
  return `${channel}_${title}${extension}`;
}
